import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TextareaMixin } from '../../mixins/components/TextareaMixin';
import FormControl from '../../js/FormControl';
var Textarea = /*#__PURE__*/styled(FormControl).withConfig({
  displayName: "Textarea",
  componentId: "c11n-8-64-0__sc-ulc0xn-0"
})(["", ""], TextareaMixin);
Textarea.displayName = 'Textarea';
Textarea.propTypes = {
  /**
   * Signals that there is an error with the value and sets the
   * [aria-invalid](https://www.w3.org/TR/wai-aria/#aria-invalid) property.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   */
  error: PropTypes.bool,

  /**
   * The textarea should fill the entire width of the container.
   */
  fluid: PropTypes.bool,

  /**
   * The [native textarea](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea)
   * "maxlength" property.
   */
  maxLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Control the css `resize` property
   */
  resize: PropTypes.oneOf(['both', 'horizontal', 'vertical', 'none']),

  /**
   * The [native textarea](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea)
   * "rows" property.
   */
  rows: PropTypes.string,

  /**
   * Mark the textarea as required with the native [`required`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/required)
   * attribute.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   */
  required: PropTypes.bool,

  /**
   * Mark the textarea as disabled with the native [`disabled`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/disabled)
   * attribute.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   */
  disabled: PropTypes.bool,

  /**
   * styled-components forwarded `as` component.
   * @ignore
   */
  forwardedAs: PropTypes.string,

  /**
   * Mark the input as disabled with the native [`disabled`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/disabled)
   * attribute.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   *
   * @since 8.27.0
   */
  readOnly: PropTypes.bool
};
Textarea.defaultProps = {
  fluid: true,
  resize: 'none',
  rows: '3',
  forwardedAs: 'textarea'
};
/** @component */

export default Textarea;
export var StyledTextarea = Textarea;